import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import APropos from "@/pages/APropos";

export const Route = createFileRoute("/a-propos")({
  head: () =>
    routeHead({
      path: '/a-propos',
      title: 'À propos | JIIA Studio, Charline Jacob',
      description: "Architecte d'intérieur et designer de concept à Lyon. Trois formations, sept ans en agence, une méthode fondée sur la couleur et le sur-mesure.",
    }),
  component: APropos,
});
